export const PHONE_REGEX = /[^\d+]/g;
